import {
  PageEntity,
} from './pageEntity';
import { AlreadyRead } from './valueObjects/alreadyRead';
import { ChildId } from './valueObjects/childId';
import { Comment } from './valueObjects/comment';
import { ConditionNote } from './valueObjects/conditionNote';
import { ConditionType } from './valueObjects/conditionType';
import { IsSent } from './valueObjects/isSent';
import { MoodCategory } from './valueObjects/moodCategory';
import { ParentId } from './valueObjects/parentId';
import { RecordDate } from './valueObjects/recordDate';
import { RecorderId } from './valueObjects/recorderId';
import { RecorderName } from './valueObjects/recorderName';
import { RecorderType } from './valueObjects/recorderType';

import type {
  PagePropsPub,
  PagePropsPvt,
} from './pageEntity';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/types/common/entityPub';
import type { PageJson, PageJsonPub, PageJsonPvt } from '@/types/domain/childNotebook/entities/pageEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * ページファクトリ
 */
export class PageFactory extends FactoryPub<
  PageEntity,
  PagePropsPvt,
  PageJsonPvt,
  PagePropsPub,
  PageJsonPub
> {
  /**
   * 比較する
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  comparePub = (
    a: PageJson,
    b: PageJson,
  ) => {
    const da = new Date(a.data.recordDate);
    const db = new Date(b.data.recordDate);
    return da < db ? 1 : -1;
  };

  /**
   * Entityを生成する
   * @param props プロパティプライベート
   * @param propsPub プロパティ公開
   * @returns Entity
   */
  create(
    props: PagePropsPvt,
    propsPub: EntityPubNotNullType<PagePropsPub>,
  ): PageEntity {
    return new PageEntity(props, propsPub);
  }

  /**
   * データからEntityを作成
   * @param props データ
   * @returns Entity
   */
  createFromEntityDataPub(
    props: EntityDataPubNotNullType<PageJsonPvt, PageJsonPub>,
  ): PageEntity {
    return this.create({
      parentId: ChildId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      recorderId: RecorderId.create(props.data.recorderId),
      recorderType: RecorderType.create(props.data.recorderType),
      recorderName: RecorderName.create(props.data.recorderName),
      recordDate: RecordDate.create(new Date(props.data.recordDate)),
      moodCategory: MoodCategory.create(props.data.moodCategory),
      conditionType: props.data.conditionType
        ? ConditionType.create(props.data.conditionType) : undefined,
      conditionNote: props.data.conditionNote
        ? ConditionNote.create(props.data.conditionNote) : undefined,
      comment: Comment.create(props.data.comment),
      images: props.data.images.map((v) => v),
      attachments: props.data.attachments.map((v) => v),
      isSent: IsSent.create(props.data.isSent),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {
        alreadyRead: AlreadyRead.create(props.pub.data.alreadyRead),
      },
    });
  }
}
